import { useEffect, useState, useRef } from 'react'
import API from '../Services/AddPackage'
import { ToastContainer, toast } from "react-toastify";
import moment from "moment";
import LocationList from './Location';
import CenterModal from './CenterModal';
import PackageDescription from "../Components/PackageDescription";

const AddPackageList = () => {
    const [packageList, setPackageList] = useState([])
    const perPage = 10
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [id, setId] = useState(null)
    const [name, setName] = useState("")
    const [locationId, setLocationId] = useState("")
    const [amount, setAmount] = useState("")
    const [weakendAmount, setWeakendAmount] = useState("")
    const [createdDate, setCreatedDate] = useState("");
    const [status, setStatus] = useState("");
    const [errors, setErrors] = useState({});
    const [description, setDescription] = useState([""]);
    const [time, setTime] = useState("")
    const [type, setType] = useState("")
    const [locationName, setLocationName] = useState("")
    const summernoteRef = useRef(null);
    const [editorValue, setEditorValue] = useState('');
    const [specialAmount, setSpecialAmount] = useState("");
    const [weekdays, setWeekdays] = useState({
        Sunday: false,
        Monday: false,
        Tuesday: false,
        Wednesday: false,
        Thursday: false,
        Friday: false,
        Saturday: false,
    });
    const [selectedCenter, setSelectedCenter] = useState([]);

    useEffect(() => {
        getPackageList()
    }, [currentPage])

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "name":
                setName(value);
                break;
            case "locationId":
                setLocationId(value);
                break;
            // case "type":
            //     setType(value);
            //     break;
            case "amount":
                setAmount(value);
                break;
            case "weakendAmount":
                setWeakendAmount(value);
                break;
            // case "time":
            //     setTime(value);
            //     break;
            case "description":
                setDescription(value);
                break;
            case "specialAmount":
                setSpecialAmount(value);
                break;
        }
    }

    const validateFields = () => {
        const errors = {};
        if (!name) {
            errors.name = "Name is required";
        } else if (!/^[A-Za-z\s]+$/.test(name)) {
            errors.name = "Name can only contain letters and spaces";
        }
        if (!locationId) { errors.locationId = "Center is required" }
        if (!String(amount).trim()) errors.amount = "Amount is required.";
        // if (!String(weakendAmount).trim()) errors.weakendAmount = "Weakend Amount is required.";
        if (!description) { errors.description = "Description is required" }


        setErrors(errors);
        return Object.keys(errors).length === 0;
    }

    const getPackageList = async () => {
        try {
            const payload = {
                id: null,
                limit: perPage,
                page: currentPage,
                type: null,

            };
            //console.log('', payload);
            const response = await API.getPackage(payload);
            // console.log("response data....", response?.data)
            setPackageList(response?.data?.result)
            setTotalRecords(response?.data?.totalCount)
        } catch (error) {
            toast.dismiss();
            if (!error.response) {
                toast.error("Network error! Please check your internet connection");
            } else if (error.response.status === 403) {
                window.location.replace("/Login")
                toast.error("Network error! Please check your internet connection.");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };

    const totalPages = Math.ceil(totalRecords / perPage);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            // getPlayPointList();
        }
    };

    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);
            if (left > 2) {
                pageNumbers.push(1, '...');
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push('...', totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    };
    const extractHtmlItems = (html) => {
        if (!html) return [];
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        // Select <p> and <li> in document order
        const nodes = Array.from(doc.body.querySelectorAll("p, li"));
        return nodes.map((n) => n.textContent?.trim() || "").filter(Boolean);
    };

    const normalizeDescriptions = (description) => {
        if (!description) return [];
        if (Array.isArray(description)) {
            return description.flatMap((d) => {
                if (typeof d === "string" && /<\/?p>|<\/?li>/i.test(d)) {
                    return extractHtmlItems(d);
                }
                return String(d).trim() ? [String(d).trim()] : [];
            });
        }
        if (typeof description === "string") {
            if (/<\/?p>|<\/?li>/i.test(description)) {
                return extractHtmlItems(description);
            }
            return description.trim() ? [description.trim()] : [];
        }
        return [];
    };
    function removeOuterQuotes(str = "") {
        if (typeof str !== "string") return "";
        str = str.trim();
        if (
            (str.startsWith('"') && str.endsWith('"')) ||
            (str.startsWith("'") && str.endsWith("'"))
        ) {
            return str.slice(1, -1);
        }
        return str;
    }

    const handleGetData = async (ids) => {
        try {
            const response = await API.getPackage({ id: ids });
            const fetchedData = response?.data?.result?.[0];
            // console.log("fetchdata...", fetchedData);
            if (fetchedData) {
                setId(fetchedData.id);
                setName(fetchedData?.package_name);
                setLocationId(fetchedData?.location_id);
                setAmount(fetchedData?.amount_per_person);
                setWeakendAmount(fetchedData?.weekend_addon_amount);
                setStatus(fetchedData?.is_active);
                setCreatedDate(fetchedData?.createdAt);
                setLocationName(fetchedData?.location_name);
                setSpecialAmount(fetchedData?.special_price);
                // Weekdays
                let weekdaysObject = {};
                const weekdaysArray = fetchedData?.week_list
                    ? fetchedData?.week_list.split(",").map((day) => day.trim())
                    : [];

                if (weekdaysArray.includes("All Days")) {
                    weekdaysObject = allWeekdays.reduce((acc, day) => {
                        acc[day] = true;
                        return acc;
                    }, {});
                } else {
                    weekdaysObject = allWeekdays.reduce((acc, day) => {
                        acc[day] = weekdaysArray.includes(day);
                        return acc;
                    }, {});
                }
                let parsedDescription = [];
                if (typeof fetchedData.description === "string") {
                    let raw = removeOuterQuotes(fetchedData.description);
                    try {
                        const maybe = JSON.parse(raw);
                        if (Array.isArray(maybe)) {
                            parsedDescription = maybe.map((d) =>
                                typeof d === "string" ? removeOuterQuotes(d.trim()) : String(d)
                            );
                        } else if (typeof maybe === "string") {
                            parsedDescription = [removeOuterQuotes(maybe.trim())];
                        } else {
                            parsedDescription = [raw];
                        }
                    } catch {

                        parsedDescription = [removeOuterQuotes(raw)];
                    }
                } else if (Array.isArray(fetchedData.description)) {
                    parsedDescription = fetchedData.description.map((d) =>
                        typeof d === "string" ? removeOuterQuotes(d.trim()) : String(d)
                    );
                }
                const finalDesc = parsedDescription.length ? parsedDescription : [""];
                setDescription(finalDesc);
                setEditorValue(finalDesc);
                const joined = Array.isArray(finalDesc) ? finalDesc.join("\n") : finalDesc;
                if (summernoteRef.current?.setHtml) {
                    summernoteRef.current.setHtml(joined);
                }

                const currentContent = summernoteRef.current?.getContent();
                // console.log("fff", finalDesc, "editor reads:", currentContent);
            } else {
                toast.error("Failed to fetch SkyCoins details.");
            }
        } catch (error) {
            if (error?.response?.status === 404) {
                toast.error("Resource not found (404)");
            } else if (error?.response?.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching data:", error);
        }
    };

    const updatePackageList = async () => {
        const selectedDaysArr = Object.keys(weekdays).filter(day => weekdays[day]);
        const weekList = selectedDaysArr.length === 7 ? "All Days" : selectedDaysArr.join(", ");

        const descriptions = summernoteRef.current?.getContent();
        // console.log('content', description);
        try {
            const payload = {
                location_id: locationId,
                name: name,
                type: "food",
                amount_per_person: parseFloat(amount),
                weekend_addon_amount: parseFloat(0),
                description: descriptions,
                time: parseInt(0),
                week_days: 'All Days',
                special_price:specialAmount
                //  week_days: weekList,

            };
            const response = await API.updatePackage(id, payload);
            if (response?.status === 200) {
                toast.success(response?.data?.message);
                getPackageList()
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Failed to update SkyCoins. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found (404)');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error updating designation:", error);
            toast.error("An unexpected error occurred. Please try again later.");
        }
    }

    const handleSubmit = async () => {
        if (!validateFields()) return;
        await updatePackageList();
    };

    const changeStatus = async (id, currentStatus) => {
        // console.log("stauttsss..", id, currentStatus)
        const updatedStatus = !currentStatus;
        try {
            const response = await API.changePackageStatus(id, updatedStatus);
            if (response.status === 200) {
                setPackageList((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(
                    `Package ${updatedStatus ? "Activated" : "De-Activated"} successfully!`
                );
                getPackageList();
            } else {
                console.log("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found (404)');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.log("Error in status toggle:", error);
            toast.error("Failed to update the status. Please try again.");
        }
    };

    const allWeekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    const handleWeekdayChange1 = (day) => {
        setWeekdays((prevWeekdays) => ({
            ...prevWeekdays,
            [day]: !prevWeekdays[day],
        }));
    };

    const handleSelectedCenter = (selectedData) => {
        setSelectedCenter(selectedData);
    };

    return (
        <div>

            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Added Food Package</h4>
                    </div>
                    <div className="card-body">
                        {/* <div className="row mb-3">
                            <div className="col-md-4">
                                <CenterModal onSelectCenter={handleSelectedCenter} />
                            </div>
                            <div className="col-md-3">
                                <label></label>
                                <button
                                    type="button"
                                    className="btn btn-success mt-3"
                                >Search</button>
                            </div>
                        </div> */}
                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>SrNo</th>
                                        <th>Action</th>
                                        <th>Name</th>
                                        <th>Center name</th>
                                        {/* <th>Type</th> */}
                                        <th>MRP (Normal)</th>
                                        <th>MRP (SPCL)</th>
                                        {/* <th>Weekend Amount</th> */}
                                        {/* <th>Time</th> */}
                                        <th>Status</th>
                                        <th>Created-Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {packageList.map((item, index) => (

                                        <tr key={item.id} data-active={item?.is_active ? "true" : "false"}>
                                            <td>{(currentPage - 1) * perPage + index + 1}</td>

                                            <td>
                                                <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                    <ul className="navbar-nav navbar-nav-right">
                                                        <li className="nav-item nav-profile1">
                                                            <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <div className="nav-profile-text1">
                                                                    <p className="mb-1 text-black">
                                                                    </p>
                                                                </div>
                                                            </span>
                                                            <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                            <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                                <a className="dropdown-item">
                                                                    <button
                                                                        onClick={() => handleGetData(item.id)}
                                                                        className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalTaxView">
                                                                        View
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    <button
                                                                        onClick={() => handleGetData(item.id)}
                                                                        className="btn btn-primary btn-sm" type="button"
                                                                        data-bs-toggle="modal" data-bs-target="#myModal"
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    {/* {localStorage.getItem("location_id") !== item.id && ( */}
                                                                    <button
                                                                        className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                        onClick={() => changeStatus(item.id, item.is_active)}
                                                                    >
                                                                        {item.is_active ? "De-Activate" : "Activate"}
                                                                    </button>
                                                                    {/* )} */}
                                                                </a>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>
                                            <td>{item.package_name}</td>
                                            <td>{item.location_name}</td>
                                            {/* <td>{item.type}</td> */}
                                            <td>{item.amount_per_person}</td>
                                            <td>{item?.special_price}</td>
                                            {/* <td>{item.weekend_addon_amount}</td> */}
                                            {/* <td>{item.time}</td> */}
                                            <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                                            <td>
                                                {moment(item.createdAt).format("DD-MM-YYYY")}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination justify-content-center mt-4">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Previous
                                        </button>
                                    </li>
                                    {getPageNumbers().map((page, index) => (
                                        <li
                                            key={index}
                                            className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                        >
                                            {page === "..." ? (
                                                <span className="page-link">...</span>
                                            ) : (
                                                <button className="page-link" onClick={() => handlePageChange(page)}>
                                                    {page}
                                                </button>
                                            )}
                                        </li>
                                    ))}

                                    <li
                                        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>

                </div>
            </div>
            <section>
                <div className="modal" id="myModalTaxView" data-bs-backdrop="static">
                    <div className="modal-dialog modal-lg" style={{ width: "800px" }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Package Details</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="col-lg-12 grid-margin stretch-card">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-bordered text-center">
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                            <th colSpan={3}>Center Name</th>
                                                            {/* <th>Weakend Amount</th> */}
                                                        </tr>
                                                        <tr>
                                                            <td>{name}</td>
                                                            <td colSpan={3}>{locationName}</td>
                                                            {/* <td>{weakendAmount}</td> */}
                                                        </tr>
                                                        <tr>
                                                            <th>MRP (Normal)</th>
                                                            <th>MRP (SPCL)</th>
                                                            <th>Created Date</th>
                                                            <th>Status</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{amount}</td>
                                                            <td>{specialAmount}</td>
                                                            <td>{moment(createdDate).format("DD-MM-YYYY")}</td>
                                                            <td>{status ? "Active" : "De-Activated"}</td>
                                                        </tr>
                                                        {(() => {
                                                            const items = normalizeDescriptions(description);
                                                            if (items.length === 0) return null;
                                                            return Array.from({
                                                                length: Math.ceil(items.length / 2),
                                                            }).map((_, rowIndex) => {
                                                                const firstItem = items[rowIndex * 2];
                                                                const secondItem = items[rowIndex * 2 + 1];
                                                                return (
                                                                    <tr key={rowIndex}>
                                                                        {rowIndex === 0 ? (
                                                                            <>
                                                                                <td>
                                                                                    <strong>Description</strong>
                                                                                </td>
                                                                                <td style={{ textAlign: "left" }}>
                                                                                    {firstItem
                                                                                        ? `${rowIndex * 2 + 1}. ${firstItem}`
                                                                                        : ""}
                                                                                </td>
                                                                                <td style={{ textAlign: "left" }}>
                                                                                    {secondItem
                                                                                        ? `${rowIndex * 2 + 2}. ${secondItem}`
                                                                                        : ""}
                                                                                </td>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <td></td>
                                                                                <td style={{ textAlign: "left" }}>
                                                                                    {firstItem
                                                                                        ? `${rowIndex * 2 + 1}. ${firstItem}`
                                                                                        : ""}
                                                                                </td>
                                                                                <td style={{ textAlign: "left" }}>
                                                                                    {secondItem
                                                                                        ? `${rowIndex * 2 + 2}. ${secondItem}`
                                                                                        : ""}
                                                                                </td>
                                                                            </>
                                                                        )}
                                                                    </tr>
                                                                );
                                                            });
                                                        })()}
                                                    </thead>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="modal" id="myModal" data-bs-backdrop="static">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Update Package</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="name">Name <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtname"
                                                placeholder="Name"
                                                value={name}
                                                onChange={(e) => handleFieldChange(e, "name")}
                                            />
                                            {errors.name && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.name}</span>}

                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        {/* <div className="form-group">
                                        <label htmlFor="Country">Location ID</label>
                                        <select className="form-select" id="ddlLocation"
                                            value={locationId}
                                            onChange={(e) => handleFieldChange(e, "locationId")}>
                                            <option value={1}>1</option>
                                            <option value={2}>2</option>
                                        </select>
                                    </div> */}
                                        <div className="form-group">
                                            <LocationList
                                                selectedLocation={locationId}
                                                label="Center"
                                                isRequired={false}
                                                disabled={true}
                                                setSelectedLocation={(location) => {
                                                    setLocationId(location);
                                                    if (location.trim()) {
                                                        setErrors((prevErrors) => {
                                                            const updatedErrors = { ...prevErrors };
                                                            delete updatedErrors.locationId;
                                                            return updatedErrors;
                                                        });
                                                    }
                                                }}
                                            />

                                        </div>

                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="name">MRP (Normal) <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtamount"
                                                placeholder="Amount"
                                                value={amount}
                                                onChange={(e) => handleFieldChange(e, "amount")}
                                            />
                                            {errors.amount && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.amount}</span>}
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="name">MRP (SPCL) </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtamount"
                                                placeholder="specialAmount"
                                                value={specialAmount}
                                                onChange={(e) => handleFieldChange(e, "specialAmount")}
                                            />
                                            {errors.amount && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.amount}</span>}
                                        </div>
                                    </div>


                                </div>
                                <div className="row">
                                    <div className="col-md-12">

                                        <PackageDescription ref={summernoteRef} initialValue={editorValue} />

                                    </div>
                                </div>


                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-primary" onClick={handleSubmit} >Update</button>
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <ToastContainer /> */}
        </div>

    )
}

export default AddPackageList

